// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__-GjuD","projects__heading":"Projects_projects__heading__HyZJE","projects__project":"Projects_projects__project__ASyOg"};